/**
 * =====================================================
 * Core store
 * =====================================================
 *
 * Handles core states and behavior of the application.
 *
 * =====================================================
 */
export default {
  namespaced: true,
  strict: process.env.APP_ENV === 'development',
  state () {
    return {
      drawer: window.innerWidth > 1264 || false,
      downloadPath: '',
      previousRoute: '',
      previousRouteLabel: '',
      nextRoute: '',
      nextRouteLabel: '',
      route: '',
      loading: false
    }
  },
  mutations: {
    /**
     * Sets the current route.
     *
     * @param state
     * @param route
     */
    setRoute (state, route) {
      state.route = route
    },

    /**
     * Sets the previous route.
     *
     * @param state
     * @param previousRoute
     */
    setPreviousRoute (state, previousRoute) {
      state.previousRoute = previousRoute
    },

    /**
     * Sets the previous route's label.
     *
     * @param state
     * @param previousRouteLabel
     */
    setPreviousRouteLabel (state, previousRouteLabel) {
      state.previousRouteLabel = previousRouteLabel
    },

    /**
     * Sets the previous route.
     *
     * @param state
     * @param nextRoute
     */
    setNextRoute (state, nextRoute) {
      state.nextRoute = nextRoute
    },

    /**
     * Sets the next route's label.
     *
     * @param state
     * @param nextRouteLabel
     */
    setNextRouteLabel (state, nextRouteLabel) {
      state.nextRouteLabel = nextRouteLabel
    },

    /**
     * Toggles the navigation drawer.
     *
     * @param state
     * @param drawer
     */
    toggleDrawer (state, drawer) {
      state.drawer = drawer
    },

    /**
     * Set the loading.
     *
     * @param state
     * @param loading
     */
    setLoading (state, loading) {
      state.loading = loading
    },

    /**
     * Set the download path.
     *
     * @param {*} state
     * @param {*} downloadPath
     */
    setDownloadPath (state, downloadPath) {
      state.downloadPath = downloadPath
    }
  },
  actions: {
    /**
     * Set Display of Page
     *
     * @param {commit} commit
     * @param String route
     */
    displayTitle ({ commit }, route) {
      commit('setRoute', route)
    },

    /**
     * Show Loader
     *
     * @param {commit} commit
     */
    showLoader ({ commit }) {
      commit('setLoading', true)
    },

    /**
     * Hide Loader
     *
     * @param {commit} commit
     */
    hideLoader ({ commit }) {
      commit('setLoading', false)
    }
  }
}
